/**
 * Tlumaczenia quality red flags na polski — uzywane w UI (ExistingPostsPanel).
 */

export const QUALITY_FLAGS_LABELS: Record<string, string> = {
  no_content: "Brak treści",
  too_short: "Za krótki (< 300 słów)",
  thin_content: "Cienka treść (< 600 słów)",
  no_h2_structure: "Brak nagłówków H2",
  weak_structure: "Słaba struktura (< 2 H2)",
  flat_structure: "Brak H3",
  no_lists: "Brak list",
  heavy_stuffing: "Silny keyword stuffing",
  keyword_stuffed: "Keyword stuffing",
  no_outbound_links: "Brak linków wychodzących",
  no_internal_links: "Brak linków wewnętrznych",
  stale_content: "Przestarzała treść (>3 lat, brak update)",
  no_meta: "Brak meta description",
  no_featured_image: "Brak obrazu wyróżniającego",
  no_images_in_content: "Brak obrazów w treści",
};

export function qualityFlagLabel(flag: string): string {
  return QUALITY_FLAGS_LABELS[flag] ?? flag;
}
